import { map, startWith } from 'rxjs/operators';
import { DiagnosticsDataService } from './../../../Services/diagnosticsData.service';
import { Component, OnInit } from '@angular/core';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { Teacher, Teachers, DiagnosticsVM } from 'src/app/Elearning-Models';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DiagnosticsDashboardComponent implements OnInit {

  isAdmin: boolean;
  teacherOptions: Teacher[];
  filteredTeachers: Observable<Teacher[]>;
  currentTeacherID: number;
  diagnosticsLoading: boolean = false;
  diagnosticsData: DiagnosticsVM[];
  teacherControl = new FormControl();

  private diagnosticsDataService: DiagnosticsDataService;

  constructor(
    private serviceFactory: IServiceFactory,
    private APIService: IAPIService
  ) {
    this.diagnosticsDataService = this.serviceFactory.getDiagnosticsDataService();
  }

  ngOnInit(): void {
    this.diagnosticsDataService.getTeachersForAdmin().subscribe(
      (response: Teachers) => {
        this.teacherOptions = response.Teachers;
        this.isAdmin = response.IsAdmin;
        if(!this.isAdmin) {
          this.getDiagnosticsDataForTeacher();
        }
        this.filteredTeachers = this.teacherControl.valueChanges.pipe(
          startWith(''),
          map((value) => this._filterTeacherByName(value))
        )
    })
  }

  teacherChanged = (teacherID: number) => {
    if(this.currentTeacherID !== teacherID) {
      this.currentTeacherID = teacherID;
      this.getDiagnosticsDataForAdmin(teacherID);
    }
  }

  getDiagnosticsDataForTeacher = () => {
    this.diagnosticsLoading = true;
    this.APIService.GetDiagnosticDataForTeacher().subscribe(response => {
      this.diagnosticsData = response;
      this.diagnosticsLoading = false;
    })
  }

  getDiagnosticsDataForAdmin = (teacherID: number) => {
    this.diagnosticsLoading = true;
    this.APIService.GetDiagnosticDataForAdminByTeacherID(teacherID).subscribe(response => {
      this.diagnosticsData = response;
      this.diagnosticsLoading = false;
    })
  }



  clearTeacherValue = () => {
    this.teacherControl.setValue('');
  }

  private _filterTeacherByName(value: string): Teacher[] {
    const filterValue = value.toLowerCase();
    return this.teacherOptions.filter((teacher) =>
      (teacher.FirstName.toLowerCase() + " " + teacher.LastName.toLowerCase()).includes(filterValue)
    );
  }

}
